import { parseRequiredDate } from "../misc/utility";

export interface IMeetingLookupRequest {
    DateFrom?: Date;
    DateTo?: Date;
    HighlightPersonId?: string;
}

export interface IMeetingLookupResult {
    Id: string;
    MeetingDate: string;
    MeetingTime: string;
    MeetingType: number;
    Location: string;
    Designation: string;
    OrganizationId: string;
    OrganizationName: string;
    IsHighlightedPersonAttending: boolean;
}

export class MeetingLookupResult {
    Id: string;
    MeetingDate: Date;
    MeetingTime: string;
    MeetingType: number;
    Location: string;
    Designation: string;
    OrganizationId: string;
    OrganizationName: string;
    IsHighlightedPersonAttending: boolean;

    constructor(src: IMeetingLookupResult) {
        this.Id = src.Id;
        this.MeetingDate = parseRequiredDate(src.MeetingDate);
        this.MeetingTime = src.MeetingTime;
        this.MeetingType = src.MeetingType;
        this.Location = src.Location;
        this.Designation = src.Designation;
        this.OrganizationId = src.OrganizationId;
        this.OrganizationName = src.OrganizationName;
        this.IsHighlightedPersonAttending = src.IsHighlightedPersonAttending;
    }
}
